// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"955bf4d98b22cc5e4c7e","293":"010f7db0b2ae29481a82"}[chunkId] + ".js";
};